import { Language } from './Language';

export class Serbian extends Language {
  public toIETF(): string {
    return 'sr-Cyrl-RS';
  }

  public toButtonText(): string {
    return 'Српски';
  }

  public isSelectedLanguage(i18nLang: string): boolean {
    return this.toIETF() === i18nLang || 'sr-RS' === i18nLang;
  }
}
